import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import styles from './FilterDetail.module.css';
import parse from 'html-react-parser';
import { getInformationById } from '../../../mock/filterMockData';
import axios from 'axios';
import { API_BASE_URL } from '../../../apiConfig';

export default function FilterDetail() {
  const { newArrivalFilterId } = useParams();
  const navigate = useNavigate();
  const [information, setInformation] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchFlterInfo = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await axios.get(
          `${API_BASE_URL}/api/v1/admin/new-filter/${newArrivalFilterId}`
        );

        const { code, data } = response.data;

        if (code === 1 && data) {
          setInformation(data);
        } else {
          setError("필터 정보 불러오기 실패")
        }
      } catch (err) {
        console.error("필터 데이터 로딩 오류: ", err);
        setError("필터 정보를 불러오는 중 오류가 발생했습니다.");
      } finally {
        setLoading(false);
      }
    };

    if (newArrivalFilterId) {
      fetchFlterInfo();
    }
  }, [newArrivalFilterId]);

  const handleDelete = async () => {
    const confirmed = window.confirm('정말로 이 필터를 삭제하시겠습니까?');
    if (confirmed) {
      try {
        await axios.delete(`${API_BASE_URL}/api/v1/admin/new-filter/${newArrivalFilterId}`);
        alert('필터가 성공적으로 삭제되었습니다.');
        navigate('/filters');
      } catch (error) {
        console.error('필터 삭제 중 오류 발생: ', error);
        alert('필터 삭제에 실패했습니다.');
      }
    }
  };

  const handleEdit = () => {
    navigate(`/filters/${newArrivalFilterId}/edit`);
  };

  const handleBack = () => {
    navigate('/filters');
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
  
    try {
      const localDate = new Date(dateString); // UTC로 해석되어 9시간 차이 발생
      // KST 보정 (UTC+9)
      localDate.setHours(localDate.getHours() + 9);
      return localDate.toISOString().split('T')[0];
    } catch (error) {
      console.error('날짜 형식 오류:', error);
      return dateString;
    }
  };
  

  if (loading) {
    return (
      <div className={styles.container}>
        <div className={styles.loadingWrapper}>
          <div className={styles.loading}>로딩 중...</div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className={styles.container}>
        <div className={styles.errorWrapper}>
          <div className={styles.error}>{error}</div>
          <button onClick={handleBack} className={styles.backButton}>
            목록으로 돌아가기
          </button>
        </div>
      </div>
    );
  }

  if (!information) {
    return (
      <div className={styles.container}>
        <div className={styles.errorWrapper}>
          <div className={styles.error}>필터를 찾을 수 없습니다.</div>
          <button onClick={handleBack} className={styles.backButton}>
            목록으로 돌아가기
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.actions}>
          <button onClick={handleBack} className={styles.actionButton}>
            목록
          </button>
        </div>
        <h1 className={styles.title}>{information.product_name}</h1>
        <div className={styles.meta}>
          <span className={styles.date}>등록일: {formatDate(information.createdAt)}</span>
          {information.updated_at && (
            <span className={styles.date}>수정일: {formatDate(information.updatedAt)}</span>
          )}
        </div>
      </div>

      <div className={styles.thumbnailWrapper}>
        <img src={information.image} alt="필터 이미지" className={styles.thumbnail} />
      </div>

      <div className={styles.content}>
        {parse(information.content)}
      </div>

      {information.link && (
        <div className={styles.linkWrapper}>
          <h4>링크:</h4>
          <a 
            href={information.link} 
            target="_blank" 
            rel="noopener noreferrer"
            className={styles.purchaseLink}
          >
            {information.link}
          </a>
        </div>
      )}

      <div className={styles.rightActions}>
        <button onClick={handleDelete} className={styles.deleteButton}>
          삭제
        </button>
        <button onClick={handleEdit} className={styles.editButton}>
          수정
        </button>
      </div>
    </div>
  );
}